module.exports = __webpack_public_path__ + "img/image-map-1-f59cbf84.png";